import React, { Component } from "react";
import { NavLink } from "react-router-dom";

const tiers = [
    {
        tag: "Tier 1 — Basic systems",
        title: "Simple deployments",
        text: "Single-purpose deployments with minimal configuration.",
        points: ["Single system deployment", "Instant provisioning", "Low resource usage", "Self-managed"],
        example: "Game server, n8n instance",
        featured: false,
        cta: "Browse systems",
    },
    {
        tag: "Tier 2 — Advanced systems",
        title: "Workflow systems",
        text: "Multi-system workflows and automation pipelines.",
        points: ["Multi-service deployments", "Automation pipelines", "Integrated workflows", "Medium complexity"],
        example: "AI pipelines, automation stacks",
        featured: true,
        cta: "Browse systems",
    },
    {
        tag: "Tier 3 — Enterprise systems",
        title: "Custom architecture",
        text: "Fully custom infrastructure for large-scale operations.",
        points: ["Custom system design", "Multi-cloud deployment", "Dedicated architecture", "Priority support"],
        example: "Enterprise AI systems",
        featured: false,
        cta: "Contact sales",
    },
];

export class PricingPage extends Component {
    render() {
        return (
            <div className="min-h-screen bg-[#f8fafc] text-[#0f172a]">

                {/* HERO */}
                <section className="bg-white border-b border-[#e2e8f0]">
                    <div className="max-w-7xl mx-auto px-6 py-16 text-center">
                        <div className="hk-eyebrow" style={{ textAlign: "center" }}>Deployment tiers</div>
                        <h1 className="text-4xl md:text-5xl font-bold tracking-tight">
                            Pick your firepower.
                        </h1>
                        <p className="text-[#64748b] mt-4 text-lg max-w-2xl mx-auto">
                            Choose the level of infrastructure complexity you want to deploy.
                            Each tier represents how powerful and customizable your system becomes.
                        </p>
                    </div>
                </section>

                {/* TIERS */}
                <section className="py-16 px-6">
                    <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-4 items-stretch">
                        {tiers.map((t) => (
                            <div
                                key={t.tag}
                                className={t.featured ? "hk-card hk-card-dark flex flex-col" : "hk-card flex flex-col"}
                            >
                                <div className="hk-eyebrow">{t.tag}</div>
                                <h4 className="font-bold text-xl mb-1">{t.title}</h4>
                                <p className={`text-sm mb-5 ${t.featured ? "text-[#cbd5e1]" : "text-[#64748b]"}`}>
                                    {t.text}
                                </p>
                                <ul className="space-y-2.5 mb-5 flex-1">
                                    {t.points.map((p) => (
                                        <li key={p} className={`flex gap-2 text-sm ${t.featured ? "text-white" : ""}`}>
                                            <span className="text-emerald-500 font-bold">✓</span> {p}
                                        </li>
                                    ))}
                                </ul>
                                <div className={`hk-mono text-[11px] mb-5 ${t.featured ? "text-[#94a3b8]" : "text-[#64748b]"}`}>
                                    ex. {t.example}
                                </div>
                                {t.cta === "Browse systems" ? (
                                    <NavLink
                                        to="/cp/deployments"
                                        className={`hk-btn w-full ${t.featured ? "" :"hk-btn-primary"}`}
                                    >
                                        {t.cta}
                                    </NavLink>
                                ) : (
                                    <button className={t.featured ? "hk-btn w-full border border-[#334155] text-white hover:bg-[#1e293b]" : "hk-btn w-full"}>
                                        {t.cta}
                                    </button>
                                )}
                            </div>
                        ))}
                    </div>
                </section>

                {/* FOOT NOTE */}
                <section className="pb-14 text-center text-[13px] text-[#64748b] px-6">
                    All deployments consume system credits. Infrastructure availability may vary by tier.
                </section>

            </div>
        );
    }
}

export default PricingPage;
